<div class="custom-background">
    <div class="row logo-margin">
        <div class="col-12 text-center">
            <img class="logo" src="./assets/images/logos/logo_bankei.png">
        </div>
    </div>
    
    <div class="row container-fluid m-0">
        <div class="col-lg-6 col-md-6 col-sm-12 login-container-padding-left my-4">
            <div class="title">Recuperar senha</div>
            <div class="subtitle">Informe os dados cadastrados para redefinir sua senha.</div>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12 login-container-padding-right">
            <form [formGroup]="resetFormGroup" #resetForm="ngForm" (ngSubmit)="onSubmit(resetFormGroup.value)">
                <div class="my-3">
                    <div class="custom-input-container">
                        <input formControlName="cpf" id="cpf" type="text" class="custom-input" [textMask]="{mask: MASKS.cpf.textMask}" />
                        <label class="custom-label" for="cpf">Usuário</label>
                    </div>
                    <div *ngIf="form.cpf.invalid && (form.cpf.dirty || form.cpf.touched)" class="custom-text-danger">
                        <div *ngIf="form.cpf.errors.required">
                            O usuário é obrigatório!
                        </div>
                        <div *ngIf="form.cpf.errors.cpf">
                            Este usuário é inválido!
                        </div>
                    </div>
                </div>
                
                <div class="my-4">
                    <div class="custom-input-container">
                        <input formControlName="email" id="email" class="custom-input" type="email" />
                        <label class="custom-label" for="email">E-mail</label>
                    </div>      
                    <div *ngIf="form.email.invalid && (form.email.dirty || form.email.touched)" class="custom-text-danger">
                        <div *ngIf="form.email.errors.required || form.email.errors.email">
                            O E-mail é obrigatório
                        </div>
                    </div>
                </div>     

                
            
                <div class="row my-2">
                    <div class="col-12 text-right pb-4 d-flex justify-content-end">
                        <button class="login-button-submit">
                            <span>Enviar</span>
                            <img src="./assets/icons/arrow-right.svg">
                        </button>
                    </div>
                    <!-- <div class="col-12 text-right py-4">
                        <button [disabled]="!resetForm.valid" type="submit" class="login-button">Enviar</button>                
                    </div> -->
                </div>
            </form>
        </div>
    </div>
</div>